import './SliderSkeleton.scss';

const SliderSkeleton = () => {

  return (
    <div className="slider__skeleton">
      <div className="slides__skeleton">
        <div className="slide__skeleton">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="para__skeleton" />
          ))}
          <div className="para__skeleton--primary" />
          <div className="para__skeleton--secondary" />
          <div className="para__skeleton--third" />
        </div>
      </div>
      <div className="dots__skeleton">
        {[...Array(5)].map((_, index) => (
            <div key={index} className="dot__skeleton" />
          ))}
      </div>
    </div>
  );
};

export default SliderSkeleton;